/**
 * Gets all numbers in the document that have the class "total" and colors them red if
 * they are negative.
 */

const colorNegativeNumbers = (attempt = 1) => {
  const totalElements = document.getElementsByClassName("total");
  const spanElements = Array.from(totalElements).map((element) =>
    element.querySelector("span")
  );
  let allDashes = true;
  spanElements.forEach((spanElement) => {
    if (spanElement) {
      const contents = spanElement.childNodes[0]?.nodeValue;
      if (contents && contents.includes("-") && contents !== "-") {
        spanElement.style.color = "red";
        allDashes = false;
      } else {
        spanElement.style.color = "black";
        if (contents !== "-") {
          allDashes = false;
        }
      }
    }
  });
  if (allDashes && attempt < 10) {
    setTimeout(() => colorNegativeNumbers(attempt + 1), 500);
  }
};

export default colorNegativeNumbers;
